// extracted by mini-css-extract-plugin
export default {"container":"CopyTooltip__container___2tb6K"};